import React, { useState, useEffect } from 'react'
import { Columns } from '../../../../components/elements'

const BikeDescription = (props) => {
  const [truncated, setTruncated] = useState(false)

  useEffect(() => {
    var textHeight = document.getElementById('profile-description-text')
    if (textHeight.offsetHeight > 150) {
      setTruncated(true)
    }
  }, [])

  let truncatedClass = truncated ? 'truncated' : 'full-text'
  return (
    <Columns>
      <Columns.Column>
        <div className="bike-description-wrapper">
          <p
            id="profile-description-text"
            className={'bike-description-text ' + truncatedClass}
          >
            {props.bike_description}
          </p>
          {truncated && (
            <div className="bike-description-read-more">
              <button
                className="button is-text"
                style={{ textDecoration: 'none' }}
                onClick={() => setTruncated(false)}
              >
                Read More
              </button>
            </div>
          )}
        </div>
      </Columns.Column>
    </Columns>
  )
}

export default BikeDescription
